export const BagSvg = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0938 7.03125H3.90625C3.47478 7.03125 3.125 7.38103 3.125 7.8125V20.3125C3.125 20.744 3.47478 21.0938 3.90625 21.0938H21.0938C21.5252 21.0938 21.875 20.744 21.875 20.3125V7.8125C21.875 7.38103 21.5252 7.03125 21.0938 7.03125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.59375 10.1562V7.03125C8.59375 5.99525 9.0053 5.00168 9.73786 4.26911C10.4704 3.53655 11.464 3.125 12.5 3.125C13.536 3.125 14.5296 3.53655 15.2621 4.26911C15.9947 5.00168 16.4062 5.99525 16.4062 7.03125V10.1562"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
